// const AfterProjectContent = () => {
//   const COLORS = {
//     primaryOrange: '#e46324',
//     primaryGreen: '#5ec250',
//     primaryDarkBlue: '#016563',
//     textOrange: '#e46d3e',
//     cardBg: '#ffffff',
//     borderColor: '#e0e0e0',
//     lightGray: '#f0f0f0',
//     darkGray: '#333',
//     mediumDarkGray: '#555',
//     newTagRed: '#ff4444',
//     disabledGray: '#cccccc',
//   };

//   const styles = {
//     mainContainerStyle: {
//       backgroundColor: COLORS.lightGray,
//       padding: '10px 20px',
//       width: '100%',
//       boxSizing: 'border-box',
//     },
//     titleStyle: {
//       color: '#333',
//       fontSize: 'clamp(20px, 2vw, 28px)',
//       fontWeight: 700,
//       marginBottom: '20px',
//       textAlign: 'center',
//       lineHeight: '1.3',
//     },
//     detailsTitleStyle: {
//       color: COLORS.darkGray,
//       fontSize: 'clamp(14px, 1.6vw, 16px)',
//       lineHeight: '1.6',
//       marginBottom: '15px',
//     },
//     listStyle: {
//       paddingLeft: '20px',
//       marginBottom: '20px',
//     },
//     listItemStyle: {
//       marginBottom: '8px',
//       fontSize: 'clamp(14px, 1.6vw, 16px)',
//       lineHeight: '1.6',
//     }
//   };

//   return (
//     <>
//       <div style={styles.mainContainerStyle}>
//         <h2 style={styles.titleStyle}>Luxury Apartments in Trichy – Security Meets Sophistication</h2>
//         <p style={styles.detailsTitleStyle}>Experience a superior lifestyle in our gated community apartments, where safety, privacy, and community living come together seamlessly. Mitha Homes' gated projects are ideal for families and professionals seeking peace of mind without compromising on modern comforts.</p>
//         <p style={styles.detailsTitleStyle}>Key highlights include:</p>
//         <ul style={styles.listStyle}>
//           <li style={styles.listItemStyle}>24/7 security systems</li>
//           <li style={styles.listItemStyle}>Landscaped open spaces</li>
//           <li style={styles.listItemStyle}>Power backup & dedicated parking</li>
//           <li style={styles.listItemStyle}>Well-planned common areas</li>
//         </ul>
//         <p style={styles.detailsTitleStyle}>Living in a Mitha Homes gated community means enjoying a calm, secure environment while staying well connected to the city.</p>

//         <h2 style={styles.titleStyle}>3 BHK Flats for Sale in Trichy – Space, Style & Comfort</h2>
//         <p style={styles.detailsTitleStyle}>Our 3 BHK flats for sale in Trichy are crafted for families who value spacious interiors and premium finishes. These homes feature expansive living areas, elegant bedrooms, modern kitchens, and stylish bathrooms—perfect for comfortable urban living.</p>
//         <p style={styles.detailsTitleStyle}>Located in prime residential zones, these flats ensure proximity to schools, hospitals, shopping hubs, and major road networks, making everyday life convenient and stress-free.</p>

//         <h2 style={styles.titleStyle}>High-Budget Flats & Luxury Apartments in Trichy</h2>
//         <p style={styles.detailsTitleStyle}>For those seeking exclusivity, Mitha Homes offers high-budget flats and luxury apartments in Trichy that redefine elegance. These residences are built with top-grade materials, contemporary architecture, and premium amenities, catering to buyers who desire a sophisticated lifestyle.</p>
//         <p style={styles.detailsTitleStyle}>If you are looking for high-budget apartments in Trichy for sale, our luxury offerings provide the perfect blend of prestige, comfort, and long-term value.</p>

//         <h2 style={styles.titleStyle}>Houses for Sale in Trichy – Premium Options Below ₹3 Crore</h2>
//         <p style={styles.detailsTitleStyle}>In addition to apartments, Mitha Homes also offers select houses for sale in Trichy, including premium independent homes and villas. If your requirement is a homes in Trichy below 3 crore, we provide well-planned options in prime residential areas with excellent appreciation potential.</p>
//       </div>
//     </>
//   );
// };

// export default AfterProjectContent;

import { useEffect, useState } from "react";

const AfterProjectContent = () => {
  const COLORS = {
    primaryGreen: "#5ec250",
    lightGray: "#f0f0f0",
    border: "#e0e0e0",
  };

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 768);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const styles = {
    container: {
      maxWidth: "1100px",
      margin: "0 auto",
      padding: isMobile ? "40px 16px" : "60px 20px",
      overflowX: "hidden",
      fontFamily: "'Plus Jakarta Sans', sans-serif",
    },

    /* ---------- TYPOGRAPHY (SAME AS BEFORE) ---------- */
    title: {
      fontSize: isMobile ? "22px" : "26px",
      fontWeight: 500,
      lineHeight: 1.3,
      marginBottom: "20px",
      color: "#494040",
    },

    highlight: {
      color: COLORS.primaryGreen,
    },

    description: {
      fontSize: isMobile ? "16px" : "18px",
      lineHeight: 1.8,
      color: "#454343",
      marginBottom: "18px",
    },

    listGrid: {
      paddingTop: "20px",
      paddingLeft: isMobile ? "30px" : "0px",
      // paddingBottom: "10px",
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
      gap: "30px 40px",
      marginBottom: "18px",
    },

    listItem: {
      fontSize: isMobile ? "16px" : "18px",
      lineHeight: 1.6,
      color: "#1f0a0a",
      display: "flex",
      alignItems: "center",
      gap: "8px",
    },

    check: {
      color: COLORS.primaryGreen,
      fontWeight: 500,
    },

    /* ---------- TOP SECTION ---------- */
    topSection: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
      gap: "40px",
      marginBottom: "50px",
    },
    fullRow: {
      // position: "absolute",
      top: "38px",
      marginRight: isMobile ? "0px" : "85px",
      gridColumn: isMobile ? "auto" : "1 / -1",
      // marginTop: "10px",
    },

    topLeft: {
      flex: "1 1 520px",
      textAlign: isMobile ? "center" : "left",
    },

    topRight: {
      // flex: "1 1 420px",
      display: "flex",
      justifyContent: isMobile ? "center" : "start",
    },

    imageWrapper: {
      position: "relative",
      maxWidth: "420px",
    },

    topImage: {
      position: "absolute",
      // top: "10px",
      left: "10px",
      width: "100%",
      borderRadius: "18px",
      objectFit: "cover",
      position: "relative",
      zIndex: 2,
    },

    imageWrapper: {
      position: "relative",
      maxWidth: "420px",
    },

    tiltBg: {
      position: "absolute",
      top: "14px",
      rihgt: "18px",
      width: "100%",
      height: "80%",
      background: "#e5e5e5",
      borderRadius: "18px",
      transform: "rotate(-4deg)",
      zIndex: 1,
    },

    /* ---------- BOTTOM GRID ---------- */
    bottomGrid: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "2fr 3fr", // 40 / 60
      // gridTemplateRows: isMobile ? "auto" : "3fr 2fr", // 60 / 40
      gap: "28px",
      alignItems: "stretch",

    },

    greenCard: {
      //  fontSize: isMobile ? "15px" : "15px",
      // lineHeight: 1.8,  
      background: COLORS.primaryGreen,
      color: "#fff",
      padding: "26px",
      borderRadius: "5px",
      gridColumn: isMobile ? "auto" : "1",
      gridRow: isMobile ? "auto" : "1",
      fontSize: isMobile ? "14px" : "15px",
      lineHeight: 1.5,
      // height: "100%",
    },

    topRightCard: {
      gridColumn: isMobile ? "auto" : "2",
      gridRow: isMobile ? "auto" : "1",
      // height: "100%",
    },

    bottomLeftCard: {
      gridColumn: isMobile ? "auto" : "1",
      gridRow: isMobile ? "auto" : "2",
      height: "80%",
    },

    imageWrapperGrid: {
      gridColumn: isMobile ? "auto" : "2",
      gridRow: isMobile ? "auto" : "2",
      height: "100%",
    },

    imageCard: {
      width: "100%",
      height: "100%",
      borderRadius: "18px",
      objectFit: "cover",
    },

    // imageWrapperGrid: {
    //   gridColumn: isMobile ? "auto" : "2",
    //   gridRow: isMobile ? "auto" : "2",
    // },

    whiteCard: {
      background: "#fff",
      border: "1px solid #ddd",
      padding: "28px",
      borderRadius: "18px",
    },

    fullWidthCard: {
      background: "#fff",
      border: `1px solid ${COLORS.border}`,
      padding: "28px",
      borderRadius: "18px",
      marginTop: isMobile ? "0" : "-40px",
    },
  };

  return (
    <div style={styles.container}>
      {/* ---------- TOP ---------- */}
      <div style={styles.topSection}>
        {/* COLUMN 1 – CONTENT */}
        <div style={styles.topLeft}>
          <h2 style={styles.title}>
            3 BHK Ready to move Flats in Trichy <br />
            <span style={styles.highlight}>Security Meets Sophistication</span>
          </h2>

          <p style={styles.description}>
            Experience a superior lifestyle in our gated community House,
            where safety, privacy, and community living come together
            seamlessly. Mitha Homes' gated projects are ideal for families and
            professionals seeking peace of mind without compromising on modern
            comforts.
          </p>

          <div style={styles.listGrid}>
            {[
              "24/7 security systems",
              "Landscaped open spaces",
              "Power backup & dedicated parking",
              "Well-planned common areas",
            ].map((item, i) => (
              <div key={i} style={styles.listItem}>
                <span style={styles.check}>✔</span> {item}
              </div>
            ))}
          </div>
        </div>

        {/* COLUMN 2 – IMAGE ONLY */}
        <div style={styles.topRight}>
          <div style={styles.imageWrapper}>
            <div style={styles.tiltBg}></div>
            <img
              src="https://mithahomes.com/backend/uploads/home/image1.png"
              alt="Luxury Apartments"
              style={styles.topImage}
            />
          </div>
        </div>

        {/* ROW 2 – FULL WIDTH */}
        <div style={styles.fullRow}>
          <p style={styles.description}>
            Living in a Mitha Homes gated community means enjoying a calm,
            secure environment while staying well connected to the city.
          </p>
        </div>
      </div>

      {/* ---------- BOTTOM ---------- */}
      <div style={styles.bottomGrid}>
        {/* TOP LEFT – GREEN CARD */}
        <div style={styles.greenCard}>
          <h2 style={{ ...styles.title, color: "#fff" }}>
            Luxury Flats in Trichy <br />
            Space, Style & Comfort
          </h2>

          <p style={styles.greenText}>
            Our 3 BHK Property for sale in Trichy are crafted for families who
            value spacious interiors and premium finishes. These homes feature
            expansive living areas, elegant bedrooms, modern kitchens, and
            stylish bathrooms— perfect for comfortable urban living.
          </p>

          <p style={styles.greenText}>
            Located in prime residential zones, these homes ensure proximity to
            schools, hospitals, shopping hubs, and major road networks, making
            everyday life convenient and stress-free.
          </p>
        </div>

        {/* TOP RIGHT – WHITE CARD */}
        <div style={styles.topRightCard}>
          <div style={styles.whiteCard}>
            <h2 style={styles.title}>
              High Budget 3 Bhk Flats
            </h2>

            <p style={styles.description}>
              For those seeking exclusivity, Mitha Homes offers high-budget luxury 3 Bhk flats available for sale  in Trichy that redefine elegance. These residences are built with top-grade materials, contemporary architecture, and premium amenities.
            </p>

            <p style={styles.description}>
              If you are looking for high-budget house in Trichy for sale, our luxury offerings provide the perfect blend of prestige, comfort, and long-term value.
            </p>
          </div>
        </div>

        {/* BOTTOM LEFT – WHITE CARD */}
        <div style={styles.bottomLeftCard}>
          <div style={styles.whiteCard}>
            <h2 style={styles.title}>
              Flats for Sale in Trichy With Premium Options
            </h2>

            <p style={styles.description}>
              In addition to house, Mitha Homes also offers premium independent property and villas. If your requirement is a property in Trichy below 3 crore, we provide well-planned options in prime residential areas with excellent appreciation potential.
            </p>
          </div>
        </div>

        {/* BOTTOM RIGHT – IMAGE */}
        <div style={styles.imageWrapperGrid}>
          <img
            src="https://mithahomes.com/backend/uploads/home/image8.jpg"
            alt="Apartment Building"
            style={styles.imageCard}
          />
        </div>
      </div>
    </div>
  );
};

export default AfterProjectContent;
